import React from 'react'
import { Card, CardContent, Grid } from '@mui/material'
import { Timestamp } from '@firebase/firestore'
import PageContainer from '../../../../components/container/PageContainer'
import Breadcrumb from '../../../../layouts/full-layout/breadcrumb/Breadcrumb'
import TagForm from './TagForm'
import TagList from './TagList'
import { TagsProvider, useTags } from '../../../../utils/context/tags/TagsContext'
import UsedInRecipes from '../UsedInRecipes'
import { getRecipeTagsInUse } from '../../utils/admin'

function TagsInUsePanel() {
  const { tags, createTags } = useTags();
  return (
    <UsedInRecipes
      label="Tags"
      fetchInUse={getRecipeTagsInUse}
      curated={tags.map((t) => t.tagName)}
      onAdd={async (value) => {
        await createTags({
          tagName: value,
          dateCreated: Timestamp.fromDate(new Date()),
          tagId: '',
        });
      }}
    />
  );
}

export default function Tags() {
  return (
    <TagsProvider>
      <PageContainer title="Admin - Spenza" description="Admin page for Spenza.">
        <Breadcrumb title="Tags" subtitle="Admin Tools" />
        <Grid container spacing={0}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Card>
              <CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TagForm />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TagList />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TagsInUsePanel />
                    </Grid>
                  </Grid>
              </CardContent>
            </Card>
          </Grid>

        </Grid>
      </PageContainer>
    </TagsProvider>
  )
}
